class EntityAttributeService extends BaseService
	@register()
	@inject '$injector'

	@entity = {}
	@attributes = {}
	@attributeType = null

	# Get entity attribute from non-flat attributes list
	getAttributeValue: (attributes, label, defaultValue = null) ->
		if !attributes?
			return defaultValue

		attribute = _.find attributes, (attributeObj) -> return angular.isDefined attributeObj[label]

		if angular.isDefined attribute
			return attribute[label]

		return defaultValue

	##
	# @param entity - Entity that possibly contains attributes
	# @param attributeType - Name of attribute type constant
	# @param defaultAttributes - Default list of attributes in format `{"name": "value"}`
	##
	setEntity: (entity, attributeType, defaultAttributes = {}) ->
		if !entity?
			throw new Error 'No entity provided'

		if !@$injector.has(attributeType)
			throw new Error("Attribute Type constant #{attributeType} does not exist")

		@entity = entity
		@attributeType = _.values(@$injector.get(attributeType))
		@attributes = {}

		if !@entity.attributes?
			@entity.attributes = {}

		# Take from entity to populate our attributes temp list
		for attributeObj in @entity.attributes
			for own attrLabel, attrValue of attributeObj
				if !@attributeTypeExists(attrLabel)
					console.error 'Entity contains Attribute Type ' + attrLabel + ' that does not exist'

					continue

				@setAttribute attrLabel, attrValue

				if defaultAttributes[attrLabel]?
					delete defaultAttributes[attrLabel]

		# Fill in default attribute values
		for own label, defaultValue of defaultAttributes
			@setAttribute label, @getAttributeValue(@entity.attributes, label, defaultValue)

	###
	@var label - Name of attribute
	@var checkValue - Also check if value is not empty string - Default true
	###
	hasAttribute: (label, checkValue = true) ->
		return @attributes[label]? && (!checkValue || !_.isEmpty(@attributes[label].value) || @attributes[label].value == 0)

	removeAttribute: (label) ->
		return if !@hasAttribute(label, false)

		@setAttribute label, null

	setAttribute: (label, value) ->
		if @attributeTypeExists(label)
			@attributes[label] =
				label: label
				value: value
		else
			throw new Error 'Attribute Type ' + label + ' does not exist'

	attributeTypeExists: (label) ->
		return @attributeType.includes(label)

	##
	# @return array[attribute] - List of attributes in attributesArray format `[{"name": "value"}, {"name": "value"}]`
	##
	getAttributes: ->
		attributes = []

		for own key, attribute of @attributes
			if !attribute.label?
				attribute.label = key

			attributeObj = {}

			attributeObj[attribute.label] = null
			attributeObj[attribute.label] = attribute.value if attribute.value != ''

			attributes.push attributeObj

		return attributes

	persistAttributes: ->
		@entity.attributes = @getAttributes()
